import { Link } from 'react-router-dom';
import { ScrollReveal } from '@/components/ui/scroll-reveal';

const SERVICES = [
  { title: 'Residential', tag: 'Homes', icon: '🏠', blurb: 'Weekly, bi-weekly, one-time. Your home, delivered spotless.' },
  { title: 'Commercial', tag: 'Offices', icon: '🏢', blurb: 'After-hours crews keeping workplaces razor-sharp.' },
  { title: 'Deep Clean', tag: 'Reset', icon: '⚡', blurb: 'Top-to-bottom detail. The reset button for your space.' },
  { title: 'Move Out', tag: 'Handover', icon: '📦', blurb: 'Deposit-saving, buyer-impressing, zero-stress moves.' },
  { title: 'Post-Construction', tag: 'Debris', icon: '🔨', blurb: 'Dust and residue gone. Reveal day ready.' },
  { title: 'Medical', tag: 'Clinical', icon: '⚕️', blurb: 'Healthcare-grade sanitation for serious spaces.' },
];

export function ServiceOverview() {
  return (
    <section className="relative py-28 bg-charcoal overflow-hidden">
      <ScrollReveal className="max-w-7xl mx-auto px-6 lg:px-10 mb-14">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-[2px] w-10 bg-electric" />
              <span className="text-electric font-display tracking-[0.4em] text-xs">// SERVICES</span>
            </div>
            <h2 className="font-display font-bold text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
              BUILT TO <span className="text-thunder">HIT HARD</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-lg">
            Swipe through the arsenal. One service fits. Six services dominate.
          </p>
        </div>
      </ScrollReveal>

      <ScrollReveal>
        <div className="hscroll overflow-x-auto pb-8">
          <div className="flex gap-6 px-6 lg:px-10 snap-x snap-mandatory">
            {SERVICES.map((s, i) => (
              <Link
                key={s.title}
                to="/contact"
                className="snap-start flex-shrink-0 w-[300px] sm:w-[340px] group relative"
              >
                <div className="skew-card bg-gradient-to-br from-charcoal-mid to-charcoal-deep border-l-4 border-electric group-hover:border-thunder transition-all overflow-hidden">
                  <div className="skew-inner p-8 h-[420px] flex flex-col justify-between">
                    <div>
                      <div className="flex justify-between items-start mb-8">
                        <div className="text-5xl">{s.icon}</div>
                        <div className="font-display text-electric text-xs tracking-[0.3em] border border-electric/40 px-3 py-1">
                          {s.tag}
                        </div>
                      </div>
                      <div className="font-display text-white/20 text-sm tracking-widest mb-2">
                        {String(i + 1).padStart(2, '0')} / 06
                      </div>
                      <h3 className="font-display font-bold text-white text-4xl mb-4 group-hover:text-thunder transition">
                        {s.title}
                      </h3>
                      <p className="text-white/60 leading-relaxed">{s.blurb}</p>
                    </div>
                    <div className="font-display text-electric text-sm tracking-[0.3em] flex items-center gap-2 group-hover:text-thunder transition">
                      BOOK IT <span className="group-hover:translate-x-2 transition-transform">→</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
        <div className="text-center mt-6 text-white/40 font-display tracking-[0.3em] text-xs">
          ← SWIPE FOR MORE →
        </div>
      </ScrollReveal>
    </section>
  );
}
